import { useObserver } from "mobx-react";
import React, { useEffect, useRef, useState } from "react";
import { use } from "react";
import { useStores } from "../../../store";
import phonePayIcon from "../../../assests/svg/phonepay.svg";
import { apiPostPut } from "../../../api/api_methods";
import { IoIosCloseCircleOutline, IoIosLock } from "react-icons/io";
import { set } from "date-fns";
import Loader from "../../reusble_components/loader";
import { FaCheck, FaCircleNotch, FaInfinity, FaTimes } from "react-icons/fa";
import { IoCloseCircleSharp, IoPeopleOutline } from "react-icons/io5";
import {
  AiFillCloseCircle,
  AiFillDelete,
  AiOutlineDelete,
  AiOutlineReconciliation,
  AiOutlineWallet,
} from "react-icons/ai";
import { FaArrowLeftLong } from "react-icons/fa6";
import { CgProfile } from "react-icons/cg";
import { IoLogOutOutline } from "react-icons/io5";
import PricingCard from "./pricingcard";
import { toJS } from "mobx";
import { useNavigate } from "react-router-dom";
import { MdOutlineClose, MdOutlineKeyboardArrowDown } from "react-icons/md";
import PricingPlanPopup from "./pricingPpup";
const Subscription = ({ gateWay = "phonePe", commingFrom, plans, yearlyPlans }) => {
  const [activeTab] = useState("plan");
  const [coderefText, setCoderefText] = useState("");
  const coderef = useRef(null);
  const rangeRefInterview = useRef(null);
  const rangeRefResume = useRef(null);
  const rangeRefJobPostings = useRef(null);
  const [isCouponThere, setIsCouponThere] = useState(null);
  const [couponValue, setCouponValue] = useState(0);
  const minPrice = 0;
  const maxPrice = 20;
  const interviewPrice = 179;
  const resumeScreeningPrice = 9;
  const [popUpInitialValue, setPopUpInitialValue] = useState(false);
  const jobPostingsPrice = 0;
  const { UserStore } = useStores();
  const [codeMsg, setCodeMsg] = useState("");
  const [isCodeApplied, setIsCodeApplied] = useState(false);
  const [planPeriod, setPlanPeriod] = useState("yearly"); // 'monthly' or 'yearly'
  const displayedPlans = planPeriod === "monthly" ? plans : yearlyPlans;
  const [loader, setLoader] = useState(false);
  const [selectedId, setSelectedId] = useState(displayedPlans?.length > 0 ? displayedPlans[0]?.id : null);
  const [showDetails, setShowDetails] = useState(false);

  const navigate = useNavigate();

  const { RecuiterStore } = useStores();

  // Compute which plans to display based on toggle

  // Ensure selectedId/selectedPlan are valid when toggling
  useEffect(() => {
    // If selectedId is not in displayedPlans, reset to first plan
    if (!displayedPlans?.find((plan) => plan.id === selectedId)) {
      setSelectedId( displayedPlans?.length > 0 ? displayedPlans[0]?.id : null  );
      setSelectedPlan(displayedPlans?.length > 0 ? displayedPlans[0] : null);
      RecuiterStore.setPaymentTotal(displayedPlans?.length > 0 ? displayedPlans[0]?.price ?? 0 : 0);
    } else {
      setSelectedPlan(displayedPlans?.find((plan) => plan.id === selectedId));
      RecuiterStore.setPaymentTotal(displayedPlans?.find((plan) => plan.id === selectedId)?.price ?? 0);
    }
    // eslint-disable-next-line
  }, [planPeriod]);

  // useEffect(() => {
  //   const URL = window.location.href;
  //   navigate(`/company/subscription?tab=${activeTab}`);
  // }, [activeTab]);

  const companyOffers = [
    {
      id: 0,
      name: "Get 5% off",
      discription: "Take 500 interviews and get 5% off ",
      minInterviews: 500,
    },
    {
      id: 1,
      name: "Get 10% off",
      discription: "Take 1000 interviews and get 10% off ",
      minInterviews: 1000,
    },
    {
      id: 2,
      name: "Get 15% off",
      discription: "Take 1500 interviews and get 15% off ",
      minInterviews: 1500,
    },
  ];

  const [selectedOffer, setSelectedOffer] = useState({});
  const [selectedOfferId, setSelectedOfferId] = useState(null);
  const [previousPendingSubscription, setPreviousPendingSubscription] =
    useState([]);
  const [prevoiusPlanPaymentUrl, setPrevoiusPlanPaymentUrl] = useState(null);

  const [selectedPlan, setSelectedPlan] = useState(displayedPlans?.length > 0 ? displayedPlans[0] : null);
  const [selectedInterviews, setSelectedInterviews] = useState(1);
  const total = selectedPlan?.price ?? 0;
  const [selectedFinalInterviews, setSelectedFinalInterviews] = useState(1);
  const [selectedResumeScreening, setSelectedResumeScreening] = useState(1);
  const [selectedJobPostings, setSelectedJobPostings] = useState(1);

  const [prevoiusPlan, setPrevoiusPlan] = useState(null);

  const maxInterviews = 1000;
  const maxInterviews2 = 10000;
  const maxResumeScreening = 10000;
  const maxJobPostings = 100;

  const isCompany = window.location.href.includes("company");

  const handleChangePlan = (id) => {
    console.log(id, "id");
    setSelectedId(id);
    setSelectedPlan(displayedPlans?.find((plan) => plan.id === id));
    setSelectedInterviews(
      displayedPlans?.find((plan) => plan.id === id).features[1].value
    );
    setSelectedResumeScreening(
      displayedPlans?.find((plan) => plan.id === id).features[0].value
    );
    setSelectedJobPostings(
      displayedPlans?.find((plan) => plan.id === id).features[8].value
    );
  };

  const handleChangePlan2 = (id) => {
    if (id !== selectedId) {
      setCodeMsg("");
      setIsCodeApplied(false);
      setCoderefText("");
      setCouponValue(0);
      setIsCouponThere(false);
      setSelectedId(id);
      setSelectedPlan(displayedPlans?.find((plan) => plan.id === id));
      if (id === 2) {
        setSelectedInterviews(1);
        setSelectedResumeScreening(1);
        setSelectedJobPostings(1);
        RecuiterStore.setSelectedInterviewsCount(1);
        RecuiterStore.setSelectedResumeAnalyzerCount(1);
        RecuiterStore.setSelectedJobPostsCount(1);
        RecuiterStore.setPaymentTotal(
          interviewPrice + resumeScreeningPrice + jobPostingsPrice
        );
        setSelectedInterviews(
          displayedPlans?.find((plan) => plan.id === id).features[1].value
        );
        setSelectedResumeScreening(
          displayedPlans?.find((plan) => plan.id === id).features[0].value
        );
        setSelectedJobPostings(
          displayedPlans?.find((plan) => plan.id === id).features[8].value
        );
        return;
      }
      RecuiterStore.setPaymentTotal(
        displayedPlans?.find((plan) => plan.id === id)?.price ?? 0
      );
    }
  };

  useEffect(() => {
    UserStore.checkAllSubscription();
    // if (prevoiusPlan.status === 200) {
    //   setPrevoiusPlan(prevoiusPlan);
    // }
    UserStore.checkAllSubscription();
    const URL = window.location.href;
    if (URL.includes("dashboard")) {
      setSelectedPlan(displayedPlans?.length > 0 ? displayedPlans[0] : null);
      RecuiterStore.setPaymentTotal(displayedPlans?.length > 0 ? displayedPlans[0]?.price ?? 0 : 0);
    } else if (URL.includes("company")) {
      setSelectedPlan(displayedPlans?.length > 0 ? displayedPlans[0] : null);
      RecuiterStore.setPaymentTotal(displayedPlans?.length > 0 ? displayedPlans[0]?.price ?? 0 : 0);
    }
  }, []);

  const handleChangeOffer = (id) => {
    if (selectedOfferId === id) {
      setSelectedOfferId(null);
      setSelectedOffer(null);
      return;
    }
    setSelectedOfferId(id);
    setSelectedOffer(companyOffers.find((offer) => offer.id === id));
    setSelectedFinalInterviews(
      companyOffers.find((offer) => offer.id === id).minInterviews
    );
  };

  useEffect(() => {
    const subscriptions = toJS(UserStore.previousAllSubscriptions);
    const lastInactiveSubscription = subscriptions
      .filter((subscription) => !subscription.isActivated)
      .pop();
    setPreviousPendingSubscription(lastInactiveSubscription ?? []);
    console.log(lastInactiveSubscription, "lastInactiveSubscription");
    try {
      if (lastInactiveSubscription?.paymentId?.gateWayResponse) {
        console.log(lastInactiveSubscription.paymentId.gateWayResponse, "res");
        const gateWayResponse = JSON.parse(
          lastInactiveSubscription.paymentId.gateWayResponse
        );
        setPrevoiusPlanPaymentUrl(
          gateWayResponse?.data.data?.instrumentResponse?.redirectInfo?.url
        );
      }
    } catch (error) {
      console.error("Error parsing JSON:", error);
    }
  }, [UserStore.previousAllSubscriptions]);

  useEffect(() => {
    localStorage.removeItem("subscription");
  }, []);

  useEffect(() => {
    const newTotal =
      (Number(RecuiterStore.interviewPrice) || 0) *
        RecuiterStore.selectedInterviewsCount +
      (Number(RecuiterStore.resumeScreeningPrice) || 0) *
        RecuiterStore.selectedResumeAnalyzerCount +
      (Number(RecuiterStore.jobPostingsPrice) || 0) *
        RecuiterStore.selectedJobPostsCount;
    if (selectedId === 2) {
      RecuiterStore.setPaymentTotal(newTotal);
      return;
    }
    // RecuiterStore.setPaymentTotal(newTotal);
    console.log(newTotal, "total");
    console.log(
      RecuiterStore.selectedInterviewsCount,
      RecuiterStore.selectedResumeAnalyzerCount,
      RecuiterStore.selectedJobPostsCount,
      RecuiterStore.paymentTotal,
      RecuiterStore.interviewPrice,
      RecuiterStore.resumeScreeningPrice,
      RecuiterStore.jobPostingsPrice,
      "Counts of all"
    );
  }, [
    RecuiterStore.selectedInterviewsCount,
    RecuiterStore.selectedResumeAnalyzerCount,
    RecuiterStore.selectedJobPostsCount,
  ]);

  const handleChangeInterviews = (e) => {
    // const interviewsCount = Number(e.target.value);
    RecuiterStore.setSelectedInterviewsCount(Number(e.target.value));
    // const resumeScreeningCount = Number(
    //   RecuiterStore.selectedResumeAnalyzerCount
    // );
    // const jobPostingsCount = Number(RecuiterStore.selectedJobPostsCount);

    // console.log(
    //   interviewsCount,
    //   "interviewsCount",
    //   selectedResumeScreening,
    //   selectedJobPostings
    // );

    // const newTotal =
    //   (Number(RecuiterStore.interviewPrice) || 0) * RecuiterStore.in +
    //   (Number(RecuiterStore.resumeScreeningPrice) || 0) * RecuiterStore.selectedResumeAnalyzerCount +
    //   (Number(RecuiterStore.jobPostingsPrice) || 0) * RecuiterStore.selectedJobPostsCount;

    // // setSelectedInterviews(interviewsCount);
    // RecuiterStore.setPaymentTotal(newTotal);

    // console.log(newTotal, "total");
  };

  const handleChangeResumeScreening = (e) => {
    // const resumeScreeningCount = Number(e.target.value) || 0; // Convert input to a number
    RecuiterStore.setSelectedResumeAnalyzerCount(Number(e.target.value));
    // const interviewsCount = Number(RecuiterStore.selectedInterviewsCount);
    // const jobPostingsCount = Number(RecuiterStore.selectedJobPostsCount);

    // const newTotal =
    //   (Number(RecuiterStore.interviewPrice) || 0) * interviewsCount +
    //   (Number(RecuiterStore.resumeScreeningPrice) || 0) * resumeScreeningCount +
    //   (Number(RecuiterStore.jobPostingsPrice) || 0) *
    //     (Number(jobPostingsCount) || 0);

    // RecuiterStore.setPaymentTotal(newTotal);
  };

  const handleChangeJobPostings = (e) => {
    // const jobPostingsCount = Number(e.target.value) || 0; // Ensure it's a number
    RecuiterStore.setSelectedJobPostsCount(Number(e.target.value));
    // const resumeScreeningCount = Number(RecuiterStore.selectedResumeScreening);
    // const interviewsCount = Number(RecuiterStore.selectedInterviewsCount);

    // const newTotal =
    //   (Number(RecuiterStore.interviewPrice) || 0) * interviewsCount +
    //   (Number(RecuiterStore.resumeScreeningPrice) || 0) * resumeScreeningCount +
    //   (Number(RecuiterStore.jobPostingsPrice) || 0) *
    //     (Number(jobPostingsCount) || 0);

    // RecuiterStore.setPaymentTotal(newTotal);
  };


  const redeemCode = async (e) => {
    e.preventDefault();
    console.log("adding loader");
    setLoader(true);
    // setLoader(true);
    console.log(coderef.current.value);
    const coupon = coderef.current.value;
    let company_id;

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      company_id = user?._id;
      console.log(company_id);
    } catch (error) {
      console.log("error occurred getting id", error);
    }

    const id = UserStore?.userDetails?._id ?? company_id;

    const resp = await apiPostPut(
      {
        code: coupon,
        userId: id,
        price: RecuiterStore.paymentTotal,
        planId: selectedPlan.id,
      },
      "/payment/check-promo-code",
      "POST"
    );
    coderef.current.value = "";

    console.log("setting loader to false");
    setLoader(false);
    setCodeMsg(resp?.body?.message);
    if (resp?.status == 200) {
      setIsCodeApplied(true);
      coderef.current.value = coupon;
      setCouponValue(
        resp?.body?.data?.data?.credits
          ? resp?.body?.data?.data?.credits
          : resp?.body?.data?.data?.discount
      );
    }
    setLoader(false);
  };

  const onSubmitForm = async (e) => {
    setLoader(true);
    const userDetails = JSON.parse(localStorage.getItem("user"));
    const userId = userDetails?._id;
    const roleId = userDetails?.role?._id;

    const bodyForCustom = {
      userId: userId,
      role: roleId,
      type: "customPlan",
      planDetails: {
        name: "customPlan",
        features: [
          {
            name: "AI Resume Analyser",
            limit: selectedResumeScreening,
            included: true,
          },
          { name: "AI Interviewer", limit: selectedInterviews, included: true },
          {
            name: "MCQ Assessments",
            limit: selectedInterviews / 2,
            included: true,
          },
          { name: "Reports", included: true },
          { name: "ATS Dashboard", included: true },
          { name: "Tags", included: true },
          { name: "Salary Recommendation", included: true },
          {
            name: "Job Posts/Month",
            limit: selectedJobPostings,
            included: true,
          },
          {
            name: "Logins",
            limit: Math.max(2, (selectedInterviews / 100).toFixed(0)),
            included: true,
          },
          { name: "Interview Backup (15)", included: true },
          { name: "In App Auto Emails", included: false },
          { name: "White-Labelling", included: true },
          { name: "shared Support", included: true },
        ],
        duration: "month",
        priceSpecification: {
          amount: total,
          currencyCode: "INR",
        },
        description: "",
        credits: total,
        planApplicableFor: roleId,
      },
    };

    const bodySub = {
      userId: userId,
      planId: selectedPlan.id,
      role: roleId,
    };
    const payload = selectedPlan.id === 2 ? bodyForCustom : bodySub;
    const response = await apiPostPut(
      payload,
      "/subscriptions/create-subscription",
      "POST"
    );

    // return;

    if (response?.status === 200) {
      // let redirectUrl = window.location.href;
      // localStorage.setItem("redirectUrl", redirectUrl);
      const body = {
        couponCode: coderef?.current?.value,
        userId,
        // money: Number(selectedPlan.price),
        subscriptionId: response?.body?.savedSubscription?._id,
      };

      if (gateWay === "razorPay") {
        const url = "/razorpay/create-order";
        // setLoader(true);
        const response = await apiPostPut(body, url, "POST");
        // setLoader(false);
        console.log(response);
        if (response?.status === 200) {
          // setLoader(true);
          // setTimeout(() => {
          //   setLoader(false);
          // }, 1000);
          //  navigate(`/payment-razorpay/${orderId}`);
        }
      } else if (gateWay === "phonePe") {
        const url = "/phonepe/create-subscription-order";
        // setLoader(true);
        const response = await apiPostPut(body, url, "POST");
        // setLoader(false);
        console.log(response);
        if (response?.status === 200) {
          localStorage.setItem("subscription", JSON.stringify(true));
          // open new tab
          const url = response?.body?.data?.paymentLink;
          // console.log(url);
          // setpaymentUrl(url);
          // return;
          // return;
          setLoader(false);
          window.open(url, "_self");
        }
      } else {
        alert(response?.body?.message);
      }
    }
    setLoader(false);
  };

  const CreditsSubmit = async (e) => {
    let redirectUrl = window.location.href;
    localStorage.setItem("redirectUrl", redirectUrl);
    // alert(InterviewStore.redirectUrl);
    if (e) {
      e.preventDefault(); // Ensure `e` is defined before calling `preventDefault()`
    }
    // call axios api

    const credits = RecuiterStore.paymentTotal;
    console.log(credits);
    const userDetails = JSON.parse(localStorage.getItem("user"));
    const userId = userDetails?._id;
    const body = {
      userId,
      interviews: RecuiterStore.selectedInterviewsCount,
      resumes: RecuiterStore.selectedResumeAnalyzerCount,
      jobPosts: RecuiterStore.selectedJobPostsCount,
      money: credits,
      couponCode: coderef?.current?.value,
    };

    const body1 = {
      userId,
      interviews: RecuiterStore.selectedInterviewsCount,
      resumes: RecuiterStore.selectedResumeAnalyzerCount,
      mcqs: RecuiterStore.selectedJobPostsCount,
      money: credits,
      couponCode: coderef?.current?.value,
    };

    const newBody = isCompany ? body : body1;

    if (gateWay === "razorPay") {
      const url = "/razorpay/create-order";
      setLoader(true);
      const response = await apiPostPut(body, url, "POST");
      setLoader(false);
      console.log(response);
      if (response?.status === 200) {
        setLoader(true);
        setTimeout(() => {
          setLoader(false);
        }, 1000);
        //  navigate(`/payment-razorpay/${orderId}`);
      }
    } else if (gateWay === "phonePe") {
      const url = "/phonepe/create-order";
      setLoader(true);
      const response = await apiPostPut(newBody, url, "POST");
      setLoader(false);
      console.log(response);
      if (response?.status === 200) {
        // open new tab
        const url = response?.body?.data?.paymentLink;
        console.log(url);
        window.open(url, "_self");
      }
    }
  };

  return useObserver(() => (
    <div className="md:mx-24 mx-4  relative">
      <PricingPlanPopup
        popUpInitialValue={popUpInitialValue}
        handlePopup={() => {
          setPopUpInitialValue(false);
        }}
      />
      <Loader loader={loader || UserStore.loader} />
      <div classname=" flex flex-row">
        <h1 className="text-3xl font-bold mb-6 tc1:mb-3 tc1:mt-16 md:mt-12">
          Purchase
        </h1>
        <div className="absolute top-1 right-0">
          <button
            onClick={() => {
              navigate(-1);
            }}
            className=""
          >
            <MdOutlineClose className="text-3xl" />
          </button>
        </div>
      </div>

      {/* <div className="flex tc1:pl-2  sm:px-5 items-center  space-x-10 md:space-x-24 lg:space-x-24 border-b-2  pl-6 ">
        <div
          className={`flex items-center text-lg space-x-3 py-2 min-w-fit cursor-pointer ${
            activeTab === "plan"
              ? "text-orange-500 border-b-2 border-primary -mb-[1.5px] px-1"
              : "hover:text-primary"
          }`}
          onClick={() => setActiveTab("plan")}
        >
          <AiOutlineReconciliation className="text-xl" />
          <label className="cursor-pointer ">Choose plan</label>
        </div>
        <div
          className={`flex items-center text-lg space-x-3 py-2 min-w-fit cursor-pointer ${
            activeTab === "interview"
              ? "text-orange-500 border-b-2 border-primary -mb-[1.5px] px-1"
              : "hover:text-primary"
          }`}
          onClick={() => setActiveTab("interview")}
        >
          <IoPeopleOutline className="text-2xl" />
          <label className="cursor-pointer ">Interview</label>
        </div>
        <div
          className={`flex items-center text-lg space-x-3 py-2 min-w-fit cursor-pointer ${
            activeTab === "credits"
              ? "text-orange-500 border-b-2 border-primary -mb-[1.5px] px-1"
              : "hover:text-primary"
          }`}
          onClick={() => setActiveTab("credits")}
        >
          <AiOutlineWallet className=" text-2xl" />
          <label className="cursor-pointer">Credits</label>
        </div>
      </div> */}

      {activeTab === "plan" && (
        <div className=" border-t-2">
          {previousPendingSubscription !== undefined &&
            previousPendingSubscription !== null &&
            Object.keys(previousPendingSubscription).length > 0 &&
            !UserStore.previousSubscriptions && (
              <div className="relative bg-black text-white p-4 mt-5 rounded-lg shadow-lg sm:w-auto w-[95%] mx-auto">
                <span className="flex justify-between items-center w-[98%]">
                  <h1 className="pb-2 gil-med">
                    Prevoius Pending Subscription
                  </h1>
                  <button
                    className=" flex gap-1 md:-mr-5 items-center text-red-600 rounded-lg px-2 py-1  my-1 -mt-2.5 text-xs "
                    onMouseEnter={(e) => {
                      e.currentTarget
                        .querySelector("svg")
                        .classList.add("hidden");
                      e.currentTarget
                        .querySelector(".hover-icon")
                        .classList.remove("hidden");
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget
                        .querySelector("svg")
                        .classList.remove("hidden");
                      e.currentTarget
                        .querySelector(".hover-icon")
                        .classList.add("hidden");
                    }}
                    onClick={() => {
                      setPreviousPendingSubscription({});
                      UserStore.deleteSubscription(
                        previousPendingSubscription._id
                      );
                      console.log(previousPendingSubscription, "delete");
                    }}
                  >
                    <AiOutlineDelete className="text-red-600 text-lg" />
                    <AiFillDelete className="text-red-600 text-lg hidden hover-icon" />
                  </button>
                </span>
                <div className="grid grid-cols-2 sm:grid-cols-6 gap-4 items-center border-t border-opacity-90 border-dashed pt-2">
                  {/* First Row: Assessment Name and Assessment Type Side by Side */}
                  <div className="col-span-1">
                    <p className="text-[#F3DEBE] gil-med">Plan</p>
                    <p className="mt-1 text-sm gil-med">
                      {previousPendingSubscription?.planId?.name}
                    </p>
                  </div>
                  <div className="col-span-1">
                    <p className="text-[#F3DEBE] gil-med">
                      {previousPendingSubscription?.featureUsage
                        ? previousPendingSubscription?.featureUsage[0].name
                        : 0}
                    </p>
                    <p className="mt-1 text-sm gil-med">
                      {previousPendingSubscription?.featureUsage
                        ? previousPendingSubscription?.featureUsage[0].limit
                        : 0}
                    </p>
                  </div>
                  <div className="col-span-1">
                    <p className="text-[#F3DEBE] gil-med">
                      {previousPendingSubscription?.featureUsage
                        ? previousPendingSubscription.featureUsage[1].name
                        : 0}
                    </p>
                    <p className="mt-1 text-sm capitalize gil-med">
                      {previousPendingSubscription?.featureUsage
                        ? previousPendingSubscription.featureUsage[1].limit
                        : 0}
                    </p>
                  </div>

                  {/* Second Row: Created On and Average Credit Consumption Side by Side */}
                  <div className="col-span-1">
                    <p className="text-[#F3DEBE] gil-med">
                      {previousPendingSubscription?.featureUsage
                        ? previousPendingSubscription.featureUsage[5].name
                        : 0}
                    </p>
                    <p className="mt-1 text-sm gil-med">
                      {previousPendingSubscription?.featureUsage
                        ? previousPendingSubscription.featureUsage[5].limit
                        : 0}
                    </p>
                  </div>
                  <div className="col-span-1">
                    <p className="text-[#F3DEBE] gil-med">Amount</p>
                    <p className="mt-1 text-sm gil-med">
                      ₹{" "}
                      {
                        previousPendingSubscription?.planId?.priceSpecification
                          ?.amount
                      }
                    </p>
                  </div>

                  {/* Third Row: Total Applicants */}
                  <div className="col-span-1">
                    <p className="text-[#F3DEBE] gil-med">Action Required</p>
                    <div className="mt-1 text-sm flex items-center gap-2">
                      <p className="text-sm flex gap-3 items-center">
                        <a
                          className="bg-amber-500 text-white cursor-pointer rounded-lg px-3 py-1 text-sm"
                          // onClick={handleViewDetails}
                          href={prevoiusPlanPaymentUrl}
                        >
                          Pay Now
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}

          <div className="flex items-center justify-center gap-3 mt-8 mb-4">
            <span
              className={`text-sm font-medium ${
                planPeriod === "monthly" ? "text-gray-800" : "text-gray-400"
              }`}
            >
              Monthly
            </span>
            <button
              type="button"
              className={`w-10 h-5 flex items-center rounded-full p-0.5 transition-colors duration-300 ${
                planPeriod === "yearly" ? "bg-orange-500" : "bg-gray-300"
              }`}
              onClick={() => {
                setPlanPeriod(planPeriod === "monthly" ? "yearly" : "monthly");
              }}
            >
              <div
                className={`w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
                  planPeriod === "yearly" ? "translate-x-5" : "translate-x-0"
                }`}
              ></div>
            </button>
            <span
              className={`text-sm font-medium ${
                planPeriod === "yearly" ? "text-gray-800" : "text-gray-400"
              }`}
            >
              Yearly
            </span>
              <span className="px-2 py-1 text-xs bg-purple-100 text-purple-700 rounded-full font-semibold">
                Save 20%
              </span>
          </div>
          <h1 className="text-primary gil-med text-2xl mt-5">Our Plans</h1>
          <div className="flex md:flex-row md:w-full no-scrollbar overflow-x-scroll gap-2 md:gap-5 flex-col mt-5">
            {displayedPlans?.map((plan, index) => (
              <div className="w-full md:w-[26vw]" key={plan.id}>
                <PricingCard
                  id={plan.id}
                  title={plan.name}
                  price={plan.price}
                  monthPrice={plan.monthPrice}
                  duration={plan.duration}
                  interviewLabel={plan?.features[1].text}
                  resumeScreeningLabel={plan?.features[0].text}
                  jobPostingsLabel={plan?.features[8].text}
                  interviews={plan?.features[1].value}
                  resumeScreening={plan?.features[0].value}
                  jobPostings={plan?.features[8].value}
                  isSelected={plan?.id === selectedId}
                  handleClick={() => handleChangePlan2(plan.id)}

                />
              </div>
            ))}
          </div>
          <div className="md:flex md:justify-between tc1:pb-10 md:pb-0 w-full md:mt-10">
            {selectedId !== 2 ? (
              <div className="flex flex-col w-[37%] hidden md:block gap-2 p-8">
                <h1 className="text-2xl font-bold mb-3">
                  What do you get in this plan?
                </h1>
                {selectedPlan?.features?.slice(0, 7).map(
                  (feature, index) =>
                    feature.available && (
                      <div
                        key={index}
                        className="flex justify-start text-lg items-center"
                      >
                        {" "}
                        {feature.available ? (
                          <FaCheck className="text-green-500 mr-2" />
                        ) : (
                          <FaTimes className="text-red-500 mr-2" />
                        )}
                        <p>
                          <span className={``}>
                            {feature.value ? (
                              <>
                                {feature.value === "∞"
                                  ? `Unlimited`
                                  : feature.value}{" "}
                                {""}
                              </>
                            ) : null}
                          </span>

                          {feature.text}
                        </p>
                      </div>
                    )
                )}
                <a
                  className="flex justify-start text-base hover:underline cursor-pointer ml-5 text-primary items-center "
                  onClick={(e) => {
                    e.stopPropagation();
                    setPopUpInitialValue(true);
                  }}
                >
                  View More
                </a>
              </div>
            ) : (
              <div className="flex flex-col md:w-[47%] h-fit gap-5 tc1:mt-5 md:mt-5 bg-[#f5f5f5] p-8 rounded-lg  ">
                <SelectRange
                  lable={selectedPlan?.features[1].text}
                  minPrice={minPrice}
                  maxPrice={maxInterviews}
                  rangeRef={rangeRefInterview}
                  value={RecuiterStore.selectedInterviewsCount}
                  handleChange={handleChangeInterviews}
                />
                <SelectRange
                  lable={selectedPlan?.features[0].text}
                  minPrice={minPrice}
                  maxPrice={maxResumeScreening}
                  rangeRef={rangeRefResume}
                  value={RecuiterStore.selectedResumeAnalyzerCount}
                  handleChange={handleChangeResumeScreening}
                />
                <SelectRange
                  lable={selectedPlan?.features[8].text}
                  minPrice={minPrice}
                  maxPrice={maxJobPostings}
                  rangeRef={rangeRefJobPostings}
                  value={RecuiterStore.selectedJobPostsCount}
                  handleChange={handleChangeJobPostings}
                />
              </div>
            )}
            <CalculatingTotal
              value={RecuiterStore.paymentTotal}
              interviewPrice={RecuiterStore.interviewPrice}
              couponValue={couponValue}
              handleCouponCheck={setIsCouponThere}
              isCouponThere={isCouponThere}
              onSubmitForm={selectedId === 2 ? CreditsSubmit : onSubmitForm}
              isCodeApplied={isCodeApplied}
              price={RecuiterStore.paymentTotal}
              codeMsg={codeMsg}
              coderef={coderef}
              redeemCode={redeemCode}
              setCoderefText={setCoderefText}
              coderefText={coderefText}
              setIsCodeApplied={setIsCodeApplied}
              setCodeMsg={setCodeMsg}
              selectedId={selectedId}
              isCompany={isCompany}
              setCouponValue={setCouponValue}
              showDetails={showDetails}
              setShowDetails={setShowDetails}
            />
          </div>
          <p className="text-sm text-green-500 justify-center items-center flex">
            <IoIosLock className="mr-1 text-green-500 text-lg" />
            We use Secure Checkout with end to end Encryption to protect your
            payment information
          </p>
        </div>
      )}
      {/* {activeTab === "interview" && (
        <div>
          <GetCreditsNewPopup type="screen" />
        </div>
      )}
      {activeTab === "credits" && (
        <div>
          <CreditsSection
            rangeRefCredits={rangeRefCredits}
            minPrice={minPrice}
            maxPrice={1000}
            value={valueCredits}
            setValue={setValueCredits}
            interviewPrice={1}
            isCouponThere={isCouponThereCoupon}
            setIsCouponThere={setIsCouponThereCoupon}
            couponValue={couponValueCredits}
            onSubmitForm={CreditsSubmit}
            coderef={coderefCredits}
            redeemCode={redeemCode}
            setCoderefText={setCoderefTextCredits}
            coderefText={coderefTextCredits}
            codeMsg={codeMsgCredits}
            isCodeApplied={isCodeAppliedCredits}
            setIsCodeApplied={setIsCodeAppliedCredits}
            selectedId={selectedId}
            // setCouponValue={setCouponValue}
          />
        </div>
      )} */}
    </div>
  ));
};

export const CalculatingTotal = ({
  value,
  couponValue,
  handleCouponCheck,
  isCouponThere,
  onSubmitForm,
  isCodeApplied,
  price,
  codeMsg,
  coderef,
  redeemCode,
  setCoderefText,
  coderefText,
  setCodeMsg,
  setIsCodeApplied,
  planId,
  isCompany,
  selectedId,
  setCouponValue,
  showDetails,
  setShowDetails,
}) => {
  const { RecuiterStore } = useStores();
  return useObserver(() => (
    <div className="flex flex-col  mb-20 md:mb-0 md:w-[45%] p-4 md:p-8">
      <div
        className={`flex gap-3 text-lg accent-orange-600 items-center ${
          (Number(value) - couponValue) * 0.18 + Number(value) - couponValue < 1
            ? "cursor-not-allowed"
            : "cursor-pointer"
        }`}
        onClick={() => {
          setCodeMsg("");
          if (
            (Number(value) - couponValue) * 0.18 + Number(value) - couponValue >
            0
          ) {
            handleCouponCheck(!isCouponThere);
          }
        }}
      >
        <input
          type="checkbox"
          checked={isCouponThere}
          disabled={
            (Number(value) - couponValue) * 0.18 + Number(value) - couponValue <
            1
          }
          onChange={(e) => {
            setCodeMsg("");
            console.log(e.target.checked); // Logs true when checked, false when unchecked
            handleCouponCheck(e.target.checked);
          }}
          className={`w-4 h-4 text-primary border-gray-300 rounded focus:ring-white focus:text-white ${
            (Number(value) - couponValue) * 0.18 + Number(value) - couponValue <
            1
              ? "cursor-not-allowed"
              : "cursor-pointer"
          }`}
        />

        <label
          htmlFor="coupon"
          className={`${
            (Number(value) - couponValue) * 0.18 + Number(value) - couponValue <
            1
              ? "cursor-not-allowed"
              : "cursor-pointer"
          }`}
        >
          Have a Coupon Code{" "}
        </label>
      </div>
      {isCouponThere && (
        <div className="flex  justify-between items-center mt-4">
          <form
            onSubmit={redeemCode}
            className={`bg-gray-200 py-2 relative rounded-lg px-3 w-[80%] flex items-center justify-between  ${
              isCodeApplied && "cursor-not-allowed"
            }`}
          >
            <input
              type="text"
              required
              ref={coderef}
              onChange={(e) => {
                setCoderefText(e.target.value);
                setCodeMsg("");
                if (isCodeApplied) {
                  // setCodeMsg("");
                  // setIsCodeApplied(false);
                  // setCoderefText("");
                  return;
                }
              }}
              disabled={isCodeApplied}
              className={`bg-transparent w-[70%] outline-none ${
                isCodeApplied && "cursor-not-allowed"
              }`}
            />
            {!isCodeApplied ? (
              <button
                type="submit"
                className={`text-base  ${
                  coderefText.length < 8
                    ? "text-gray-500 cursor-not-allowed"
                    : "text-primary cursor-pointer"
                }`}
              >
                Apply
              </button>
            ) : (
              <p className="text-green-500"> Applied</p>
            )}
            {isCodeApplied && (
              <p
                className="absolute right-5  top-8 text-sm w-fit ml-2 mt-2 text-red-500 cursor-pointer"
                onClick={() => {
                  setCodeMsg("");
                  setIsCodeApplied(false);
                  setCoderefText("");
                  coderef.current.value = "";
                  handleCouponCheck(true);
                  setCouponValue(0);
                }}
              >
                Remove
              </p>
            )}
          </form>
        </div>
      )}
      {!isCodeApplied ? (
        <p className="text-sm w-fit ml-2 mt-2 text-red-500">{codeMsg}</p>
      ) : (
        <p className="text-sm w-fit ml-2 mt-2 text-green-500">{codeMsg}</p>
      )}
      <div className="text-lg border-b-2 text-gray-500 font-medium border-gray-200 border-dashed pb-5">
        <h2 className="text-primary font-semibold">Total Value</h2>{" "}
        <div className="flex justify-between items-center mt-2">
          <p>Purchasing Value</p>
          <p
            className={`flex justify-between items-center ${
              planId === 2 ? "w-28" : "w-24 "
            }`}
          >
            <p className="text-xl">₹</p> {price?.toFixed(2)}{" "}
          </p>
        </div>
        {selectedId === 2 && (
          <div className="text-sm">
            {showDetails && (
              <>
                <div className="flex justify-between items-center ">
                  <p>
                    {RecuiterStore.selectedInterviewsCount} Interviews X ₹
                    {RecuiterStore.interviewPrice}
                  </p>
                  <p
                    className={`${
                      planId === 2 ? "w-28" : "w-24 "
                    } flex justify-between items-center`}
                  >
                    <p className="text-lg">₹</p>{" "}
                    {(
                      RecuiterStore.interviewPrice *
                      RecuiterStore.selectedInterviewsCount
                    ).toFixed(2)}
                  </p>
                </div>
                <div className="flex justify-between items-center ">
                  <p>
                    {RecuiterStore.selectedResumeAnalyzerCount} Resume Analyzers
                    X ₹{RecuiterStore.resumeScreeningPrice}
                  </p>
                  <p
                    className={`${
                      planId === 2 ? "w-28" : "w-24 "
                    } flex justify-between items-center`}
                  >
                    <p className="text-lg">₹</p>{" "}
                    {(
                      RecuiterStore.resumeScreeningPrice *
                      RecuiterStore.selectedResumeAnalyzerCount
                    ).toFixed(2)}{" "}
                  </p>
                </div>
                <div className="flex justify-between items-center ">
                  <p>
                    {RecuiterStore.selectedJobPostsCount}{" "}
                    {isCompany ? "Job Posts" : "MCQ's"} X ₹
                    {RecuiterStore.jobPostingsPrice}
                  </p>
                  <p
                    className={`${
                      planId === 2 ? "w-28" : "w-24 "
                    } flex justify-between items-center`}
                  >
                    <p className="text-lg">₹</p>{" "}
                    {(
                      RecuiterStore.jobPostingsPrice *
                      RecuiterStore.selectedJobPostsCount
                    ).toFixed(2)}{" "}
                  </p>
                </div>
              </>
            )}
            <button
              onClick={() => setShowDetails(!showDetails)}
              className="text-primary cursor-pointer flex items-center"
            >
              {showDetails ? "Close Breakup" : "View Breakup"}
              <MdOutlineKeyboardArrowDown
                className={` items-center justify-center mt-0.5 transition-transform duration-300 ${
                  showDetails ? "rotate-180 text-lg" : ""
                }`}
              />
            </button>
          </div>
        )}
        {isCodeApplied && couponValue && (
          <div className="flex justify-between items-center mt-2">
            <p>Coupon Code </p>
            <p
              className={` ${
                Number(couponValue) > 0 ? "text-green-500" : null
              } ${
                planId === 2 ? "w-28" : "w-24 "
              } flex justify-between items-center`}
            >
              <p className="text-xl">₹</p> - {couponValue?.toFixed(2)}{" "}
            </p>
          </div>
        )}
        <div className="flex justify-between items-center mt-2">
          <p>TAX (18%)</p>
          <p
            className={`${
              planId === 2 ? "w-28" : "w-24 "
            } flex justify-between items-center`}
          >
            <p className="text-xl">₹</p> +{" "}
            {((Number(value) - Number(couponValue)) * 0.18).toFixed(2)}{" "}
          </p>
        </div>
      </div>
      <div className="flex justify-between text-lg items-center mt-2">
        <p className="flex items-center md:text-lg text-xs md:gap-3 tc1:gap-1 whitespace-nowrap">
          Total Purchasing Value{" "}
          <img src={phonePayIcon} className="md:h-7 md:w-7 h-5 w-5" alt="" />
        </p>
        <button
          onClick={() => {
            if (
              (Number(value) - couponValue) * 0.18 +
                Number(value) -
                couponValue <
              1
            ) {
              return;
            } else {
              onSubmitForm();
            }
          }}
          className={`md:px-4  tc1:px-2 py-2 whitespace-nowrap felx justify-center items-center text-sm text-white rounded-xl ${
            (Number(value) - couponValue) * 0.18 + Number(value) - couponValue <
            1
              ? "bg-gray-300 cursor-not-allowed"
              : "bg-primary"
          }`}
        >
          Pay{" "}
          <span className="md:text-2xl tc1:text-sm md:ml-2 tc1:ml-1">
            ₹{" "}
            {(
              (Number(value) - couponValue) * 0.18 +
              Number(value) -
              couponValue
            ).toFixed(2)}
          </span>
        </button>
      </div>
      {(Number(value) - couponValue) * 0.18 + Number(value) - couponValue <
        0 && (
        <p className="text-red-500 ml-auto text-sm">
          The coupon value exceeded your purchase price.
        </p>
      )}
    </div>
  ));
};

export const SelectRange = ({
  lable,
  minPrice,
  maxPrice,
  rangeRef,
  value,
  handleChange,
}) => {
  useEffect(() => {
    rangeRef.current.value = value ?? 1;
    rangeRef.current.style.background = `linear-gradient(to right, #ff6b00 0%, #ff6b00 ${
      ((value - minPrice) / (maxPrice - minPrice)) * 100
    }%, #e5e7eb ${
      ((value - minPrice) / (maxPrice - minPrice)) * 100
    }%, #e5e7eb 100%)`;
  }, [value]);

  const handleInputChange = (e) => {
    const inputValue = parseInt(e.target.value);
    if (inputValue >= minPrice && inputValue <= maxPrice) {
      const event = {
        target: {
          value: inputValue,
        },
      };
      handleChange(event);
    }
  };

  return useObserver(() => (
    <div>
      <div className="flex items-center justify-between w-full">
        <h1 className="text-lg font-bold text-[#797171]">{lable}</h1>
        <input
          type="number"
          id="maxPrice"
          ref={rangeRef}
          className="px-3 py-0 w-16 hover:border bg-[#f5f5f5] hover:bg-white border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent text-center text-primary font-medium"
          onChange={(e) => {
            handleChange(e);
          }}
          defaultValue={value}
          value={value}
        />
      </div>
      <div className="mb-4 relative">
        <div className="relative w-full  ">
          <input
            type="range"
            ref={rangeRef}
            className="w-full !accent-orange-600 bg-gray-200 cursor-pointer input-type-range h-1"
            min={minPrice}
            max={maxPrice}
            defaultValue={value}
            onChange={(e) => {
              handleChange(e);

              // set the color to the linear greadient according to the value in %
              const percentage =
                ((e.target.value - minPrice) / (maxPrice - minPrice)) * 100;
              if (rangeRef.current) {
                rangeRef.current.style.background = `linear-gradient(to right, #ff6b00 0%, #ff6b00 ${percentage}%, #e5e7eb ${percentage}%, #e5e7eb 100%) `;
              }
            }}
          />
          {/* <div
            className="absolute bottom-[-30px] w-auto px-2 text-center bg-[#fae6d6] text-primary   text-sm py-1 rounded transform -translate-x-1/2"
            style={{ left: `calc(${(value / maxPrice) * 100}%  )` }}
          >
            <p className="w-0 left-1.5 rotate-180 -top-1 h-0 absolute  border-l-[10px] border-l-transparent border-t-[10px] border-t-[#fae6d6] border-r-[10px] border-r-transparent"></p>
            {value < 10 ? `0${value}` : value}
          </div> */}
        </div>
        <div className="flex justify-between text-black  font-medium text-base w-full -mb-2">
          <span id="minPrice">{minPrice < 10 ? `0${minPrice}` : minPrice}</span>
          <span id="maxPrice">{maxPrice < 10 ? `0${maxPrice}` : maxPrice}</span>
        </div>
      </div>
    </div>
  ));
};

export const CreditsSection = ({
  rangeRefCredits,
  minPrice,
  maxPrice,
  value,
  setValue,
  interviewPrice,
  isCouponThere,
  setIsCouponThere,
  couponValue,
  onSubmitForm,
  coderef,
  redeemCode,
  setCoderefText,
  coderefText,
  codeMsg,
  isCodeApplied,
  setIsCodeApplied,
  loader,
  setLoader,
  setCodeMsg,
}) => {
  return useObserver(() => (
    <div className=" w-full pt-10 text-black bg-white flex md:flex-row justify-between flex-col h-auto !cursor-default">
      <Loader loader={loader} text="Loading..." />
      <div className="md:w-[49%] h-fit bg-[#f5f5f5] rounded-lg flex flex-col items-start justify-start  p-8 mt-5">
        <h1 className="mb-4 text-lg text-start text-[#808080] gil-med">
          Select No. of Credits
        </h1>
        <div className="mb-4 relative w-full">
          <div className="flex justify-between text-black text-base w-full">
            <span id="minPrice">0{minPrice}</span>
            <span id="maxPrice">{maxPrice}</span>
          </div>
          <div className="relative w-full">
            <input
              type="range"
              ref={rangeRefCredits}
              className="w-full !accent-orange-600 bg-gray-200 cursor-pointer input-type-range h-0.5 "
              min={minPrice}
              max={maxPrice}
              defaultValue={value}
              onChange={(e) => {
                setValue(Number(e.target.value));
                const percentage =
                  ((e.target.value - minPrice) / (maxPrice - minPrice)) * 100;
                rangeRefCredits.current.style.background = `linear-gradient(to right, #ff6b00 0%, #ff6b00 ${percentage}%, #e5e7eb ${percentage}%, #e5e7eb 100%)`;
              }}
            />
            <div
              className="absolute bottom-[-30px] w-8 text-center bg-[#fae6d6] text-primary text-sm py-1 rounded transform -translate-x-1/2"
              style={{ left: `calc(${(value / maxPrice) * 100}%  )` }}
            >
              <p
                className="w-0 left-1.5 rotate-180 -top-1 h-0 absolute
     border-l-[10px] border-l-transparent
     border-t-[10px] border-t-[#fae6d6]
     border-r-[10px] border-r-transparent"
              ></p>
              {value}
            </div>
          </div>
        </div>
        <div className="mt-10 flex text-[#808080] justify-between items-center w-full">
          <p>
            {value} Creditsx X ₹ {interviewPrice}
          </p>
          <p>₹ {(value * interviewPrice).toFixed(2)}</p>
        </div>
      </div>
      <div
        // onClick={(e) => e.stopPropagation()}
        className="bg-white relative h-fit text-start rounded-2xl mb-4 flex flex-col p-8 py-0  w-[49%] transition-all ease-in-out duration-300 overflow-hidden"
        // style={{ transition: "height 0.3s ease-in-out" }}
      >
        <div className="flex gap-3 mt-5 text-base accent-primary items-center">
          <input
            type="checkbox"
            onChange={(e) => {
              if (e.target.checked) {
                setIsCouponThere(true);
              } else {
                setIsCouponThere(false);
              }
            }}
            className="w-4 h-4"
          />
          <label htmlFor="coupon">Have a Coupon Code </label>
        </div>
        {isCouponThere && (
          <div className="flex justify-between items-center mt-4">
            <form
              onSubmit={redeemCode}
              className="bg-gray-200 py-2 rounded-lg px-3 w-[80%] flex items-center justify-between "
            >
              <input
                type="text"
                required
                ref={coderef}
                onChange={(e) => {
                  setCoderefText(e.target.value);
                  if (isCodeApplied) {
                    setCodeMsg("");
                    setIsCodeApplied(false);
                    // setCoderefText("");
                  }
                }}
                className="bg-transparent w-[70%] outline-none"
              />
              {!isCodeApplied ? (
                <button
                  type="submit"
                  className={`text-base ${
                    coderefText.length < 8
                      ? "text-gray-500 cursor-not-allowed"
                      : "text-primary cursor-pointer"
                  }`}
                >
                  Apply
                </button>
              ) : (
                <p className="text-green-500"> Applied</p>
              )}
            </form>
          </div>
        )}
        {!isCodeApplied ? (
          <p className="text-xs w-fit ml-2 mt-2 text-red-500">{codeMsg}</p>
        ) : (
          <p className="text-xs w-fit ml-2 mt-2 text-green-500">{codeMsg}</p>
        )}
        <div className="text-base border-b-2 text-gray-500 font-medium border-gray-200 border-dashed pb-5">
          <div className="flex justify-between items-center mt-4">
            <p>Purchasing Value</p>
            <p className="w-24 flex justify-between items-center">
              <p>₹</p> {(value * interviewPrice).toFixed(2)}{" "}
            </p>
          </div>
          {isCodeApplied && couponValue && (
            <div className="flex justify-between items-center mt-4">
              <p>Discount </p>
              <p
                className={` ${
                  Number(couponValue) > 0 ? "text-green-500" : null
                } w-24 flex justify-between items-center`}
              >
                <p>₹</p> - {couponValue?.toFixed(2)}{" "}
              </p>
            </div>
          )}
          <div className="flex justify-between items-center mt-4">
            <p>TAX (18%)</p>
            <p className=" w-24 flex justify-between items-center">
              <p>₹</p> +{" "}
              {(
                (Number(value) * Number(interviewPrice) - Number(couponValue)) *
                0.18
              ).toFixed(2)}{" "}
            </p>
          </div>
        </div>
        <div className="flex justify-between text-lg items-center mt-4">
          <p className="flex items-center text-lg gap-3 whitespace-nowrap">
            Total Purchasing Value{" "}
            <img src={phonePayIcon} className="h-6 w-6" alt="" />
          </p>
          <button
            onClick={() => {
              if (
                (Number(value) * Number(interviewPrice) - couponValue) * 0.18 +
                  Number(value) * Number(interviewPrice) -
                  couponValue <
                0
              ) {
                return;
              } else {
                onSubmitForm();
              }
            }}
            className={`px-4 py-2 flex justify-center items-center whitespace-nowrap text-sm text-white rounded-xl ${
              (Number(value) * Number(interviewPrice) - couponValue) * 0.18 +
                Number(value) * Number(interviewPrice) -
                couponValue <
              0
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-primary"
            }`}
          >
            Pay
            <span className="text-xl ml-2">
              ₹{" "}
              {(
                (Number(value) * Number(interviewPrice) - couponValue) * 0.18 +
                Number(value) * Number(interviewPrice) -
                couponValue
              ).toFixed(2)}
            </span>
          </button>
        </div>
        {(Number(value) * Number(interviewPrice) - couponValue) * 0.18 +
          Number(value) * Number(interviewPrice) -
          couponValue <
          0 && (
          <p className="text-red-500 ml-auto text-sm">
            The coupon will not be applied
          </p>
        )}
      </div>
    </div>
  ));
};

export default Subscription;
